import { NeedItSooner } from 'app/modules/NeedItSooner/NeedItSooner';
import { httpClient, PostFunction } from 'pkg/httpClient/httpClient';

const NEED_IT_SOONER_URL = '/quote/translation/sooner';

interface NeedItSoonerApi {
  post: (needItSooner: NeedItSooner) => Promise<NeedItSooner>;
}

const needItSoonerApiFactory = (client: { post: PostFunction }): NeedItSoonerApi => ({
  post: (needItSooner: NeedItSooner) =>
    client.post<NeedItSooner>(NEED_IT_SOONER_URL, needItSooner).then(({ data }) => data),
});

const needItSoonerApi = needItSoonerApiFactory(httpClient);

export { needItSoonerApi, needItSoonerApiFactory };
